export default "__VITE_ASSET__C7_P6k61__"